export function RegisterPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md space-y-8 rounded-lg bg-white p-8 shadow">
        <h2 className="text-center text-2xl font-bold">Create Account</h2>
        <p className="text-center text-gray-600">Registration page coming soon</p>
      </div>
    </div>
  )
}